import Vue from 'vue'
const mutations = {
  SET_COPIED_PLAYLISTITEM_DAYTIME_RESTRICTIONS (state, restrictions) {
    Vue.set(state, 'copied_playlistitem_daytime_restrictions', restrictions)
  },
  SET_COPIED_PLAYLISTITEM_DATE_RESTRICTIONS (state, restrictions) {
    Vue.set(state, 'copied_playlistitem_date_restrictions', restrictions)
  },
  SET_COPIED_DEVICE_DAYTIME_RESTRICTIONS (state, restrictions) {
    Vue.set(state, 'copied_device_daytime_restrictions', restrictions)
  },
  SET_COPIED_DEVICE_DATE_RESTRICTIONS (state, restrictions) {
    Vue.set(state, 'copied_device_date_restrictions', restrictions)
  },
  SET_COPIED_MEDIA_TAGS (state, tags) {
    Vue.set(state, 'copied_media_tags', tags)
  },
  SET_COPIED_DEVICE_TAGS (state, tags) {
    Vue.set(state, 'copied_device_tags', tags)
  },
  SET_COPIED_LOCAL_PLAYITEMS (state, playitems) {
    Vue.set(state, 'copied_local_playitems', playitems)
  },
  SET_COPIED_SYNCRO_LISTENER (state, playitem) {
    Vue.set(state, 'copied_synchro_listener', playitem.listenSynchronize)
  },
  SET_COPIED_PLAYER_EXCEPTIONS (state, playitem) {
    Vue.set(state, 'copied_player_exceptions', {
      playOnlyInMedia: playitem.playOnlyInMedia,
      playForbiddenInMedia: playitem.playForbiddenInMedia
    })
  },
  SET_COPIED_PLAY_PROPERTIES (state, playitem) {
    Vue.set(state, 'copied_play_properties', {
      anchorX: playitem.anchorX,
      anchorY: playitem.anchorY,
      width: playitem.width,
      height: playitem.height,
      objectFit: playitem.objectFit,
      objectRotation: playitem.objectRotation,
      objectPosition: playitem.objectPosition,
      playDurationMs: playitem.playDurationMs,
      playOffsetMs: playitem.playOffsetMs,
      onEndBehaviour: playitem.onEndBehaviour,
      pausePlayOtherContent: playitem.pausePlayOtherContent
    })
  }
}
export default mutations



//////////////////
// WEBPACK FOOTER
// ./state/clipboard/clipboard.mutations.js
// module id = null
// module chunks = 